import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {
  OperationPointRequest,
  SelectedPump,
  SelectedUnits,
  CalculationResult,
  FrequencyControl,
} from 'src/app/models';
import { environment } from 'src/environments/environment';
import { ViscosityControl } from '../models/viscosity-control.model';

@Injectable({
  providedIn: 'root',
})
export class CalculationService {
  constructor(private http: HttpClient) {}

  public calculate(
    operationPoints: OperationPointRequest[],
    selectedPump: SelectedPump,
    selectedUnits: SelectedUnits,
    frequencyControl: FrequencyControl,
    viscosityControl: ViscosityControl,
    startingTorqueRatedTorque: number
  ) {
    const frequencyControlActive =
      frequencyControl.active && frequencyControl.selectedGearI !== null && frequencyControl.selectedGearI > 0;

    const viscosityControlActive =
      (viscosityControl.active && viscosityControl.viscosity !== null) || viscosityControl.viscosity !== 0;

    const request = {
      units: {
        systemId: selectedUnits.unitSystem?.id,
        capacityUnitId: selectedUnits.capacity?.id,
        pressureUnitId: selectedUnits.pressure?.id,
      },
      pump: {
        range: selectedPump.range,
        size: selectedPump.size,
        pressureStage: selectedPump.pressureStage,
        maxDifferentialPressure: selectedPump.maxDifferentialPressure,
        baseSize: selectedPump.baseSize,
        rotor: selectedPump.rotor,
        rotation: selectedPump.rotation,
      },
      frequencyControl: frequencyControlActive ? frequencyControl : { active: false },
      viscosityControl: viscosityControlActive ? viscosityControl : { active: false },
      startingTorqueRatedTorque: startingTorqueRatedTorque,
      operationPoints: operationPoints,
    };

    const calculationUrl = `${environment.calculationApi}/v1/calculate`;
    return this.http.post<CalculationResult>(calculationUrl, request);
  }
}
